// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"SearchContainer_contentWrapper__23fJE","content":"SearchContainer_content__1ncyY","section":"SearchContainer_section__39cxT"};